import { CustomerType } from "./type";

// Organizers intial state
const initialAuthState = {
  customers: null,
  customerDropdownList: [],
  isLoading: false,
  activeTab: 0
};

export const reducer = (state = initialAuthState, action) => {
  switch (action.type) {
    case CustomerType.GET_CUSTOMERS_REQUEST:
      return { ...state, isLoading: true };
    case CustomerType.GET_CUSTOMERS_SUCCESS:
      return { ...state, isLoading: false, customers: action.payload.data };
    case CustomerType.GET_CUSTOMERS_FAIL:
      return { ...state, isLoading: false, error: action.error };
    case CustomerType.GET_LISTED_CUSTOMERS_BONUS_REQUEST:
      return { ...state, isLoading: true };
    case CustomerType.GET_LISTED_CUSTOMERS_BONUS_SUCCESS:
      const customers = [...state.customers.list];
      const values = action?.payload?.data ?? [];

      const data = customers.reduce((acc, current) => {
        const selected = values.find((val) => val.id === current.id);

        if (selected) {
          acc.push({
            ...current,
            totalLevelAmount: selected.totalLevelAmount,
            totalDailyWheelAmount: selected.totalDailyWheelAmount,
            totalOfferAmount: selected.totalOfferAmount
          });
        }  else {
          acc.push({
            ...current,
            totalLevelAmount: 0,
            totalDailyWheelAmount: 0,
            totalOfferAmount: 0
          });
        }
        return acc;
      }, []);

      return { ...state, isLoading: false, customers: { ...state.customers, list: data } };
    case CustomerType.GET_LISTED_CUSTOMERS_BONUS_FAIL:
      return { ...state, isLoading: false, error: action.error };
    case CustomerType.GET_CUSTOMER_DROPDOWN_REQUEST:
      return { ...state, isLoading: true };
    case CustomerType.GET_CUSTOMER_DROPDOWN_SUCCESS:
      return { ...state, isLoading: false, customerDropdownList: action.payload.data };
    case CustomerType.GET_CUSTOMER_DROPDOWN_FAIL:
      return { ...state, isLoading: false, error: action.error };
    case CustomerType.CHANGE_CUSTOMER_TAB:
      return { ...state, activeTab: action.payload };
    default:
      return state;
  }
};
